export function toURL(url: string): URL | Error {
    try {
        return new URL(url)
    } catch (error) {
        if (error instanceof Error) return error
        return new Error('Unknown')
    }
}
